module.exports = __webpack_public_path__ + "img/profile.0c6299fb.svg";